exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#Header{height:100px;background-color:#222831;position:fixed;width:100%;z-index:100;top:0}#Header .logo-stormgroup{width:204px;height:24px;position:absolute;top:39px;left:100px;z-index:99}@media (max-width:768px){body{padding-top:70px}#Header{height:70px}#Header .logo-stormgroup{width:130px;height:20px;position:absolute;top:27px;left:50%;margin-left:-65px;z-index:99}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f595877c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Header.vue
// module id = 180
// module chunks = 0